import CmChangePicture from '../cm-change-pictures/cm-change-picture.entity';
import EpisodicCharacterPicture from '../episodic-character-pictures/episodic-character-picture.entity';
import HaLookPicture from '../ha-look-pictures/ha-look-picture.entity';
import MuLookPicture from '../mu-look-pictures/mu-look-picture.entity';
import PictureScene from '../picture-scenes/picture-scene.entity';
import Picture from '../pictures/picture.entity';
import { SosDeleteResponse, SosListResponse } from '../sos-response';

export interface EpisodicCharacterPictureDeleteResponse
	extends SosDeleteResponse {
	destroyed: {
		EpisodicCharacterPicture: EpisodicCharacterPicture[];
	};
}

export interface EpisodicCharacterPictureListResponse extends SosListResponse {
	listed: {
		CmChangePicture: CmChangePicture[];
		EpisodicCharacterPicture: EpisodicCharacterPicture[];
		HaLookPicture: HaLookPicture[];
		MuLookPicture: MuLookPicture[];
		Picture: Picture[];
		PictureScene: PictureScene[];
	};
}

export interface EpisodicCharacterPictureForEpisodicListReponse
	extends SosListResponse {
	listed: {
		EpisodicCharacterPicture: EpisodicCharacterPicture[];
	};
}
